var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "span",
    [
      _vm._v(
        "\n    " +
          _vm._s(_vm.row.startPort && _vm.row.startPort.place.name) +
          "\n    "
      ),
      _vm.row.startPort && _vm.row.endPort ? [_vm._v("-")] : _vm._e(),
      _vm._v(
        "\n    " + _vm._s(_vm.row.endPort && _vm.row.endPort.place.name) + "\n"
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }